
define("rv!templates/partials/messenger",[],function(){return { v:3,
  t:[ { t:4,
      f:[ { t:4,
          f:[ { t:7,
              e:"div",
              a:{ "class":[ "alert alert-",
                  { t:2,
                    r:"messageType" } ] },
              f:[ { t:7,
                  e:"ul",
                  m:[ { t:4,
                      f:[ "class=\"normalList\"" ],
                      n:50,
                      x:{ r:[ "messages.length" ],
                        s:"_0>1" } } ],
                  f:[ { t:4,
                      f:[ { t:7,
                          e:"li",
                          f:[ { t:3,
                              r:"." } ] } ],
                      n:52,
                      r:"messages" } ] } ] } ],
          n:50,
          x:{ r:[ "messages.length" ],
            s:"_0>0" } } ],
      n:52,
      x:{ r:[ "Errors",
          "Warnings",
          "InfoMessages" ],
        s:"[{messages:_0,messageType:\"error\"},{messages:_1,messageType:\"warning\"},{messages:_2,messageType:\"info\"}]" } } ] };});
